<template>
  <b-card>
    <b-row>
      <!-- <b-col sm="4" class="pb-1">
        <b-button
          class="w-100"
          variant="outline-primary"
          :to="{ name: 'organization-location-add' }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
          />
          {{ $t('message.Add_Location') }}
        </b-button>
      </b-col> -->
      <b-col sm="4">
        <b-form-group>
          <b-form-input
            v-model="searchQuery"
            type="search"
            class="d-inline-block"
            :placeholder="$t('message.search')"
            @input="searchBarometerSurveyDesigned"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-table
          ref="refBarometerSurveyDesignedListTable"
          :items="paginatedBarometerSurveysDesigned"
          hover
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty=""
          :empty-text="isLoading ? $t('message.loading') : $t('message.no_records')"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(actions)="data">
            <div class="flex flex-column">
              <!-- <EditButton @clicked="router.push({name: 'organization-location-edit', params: { id: data.item._id }})"/> -->
              
              <NavigationButton i18nHoverVariable="Create" v-b-modal="`create-survey-${data.item._id.toString()}`"/>
              <b-modal
                :id="`create-survey-${data.item._id.toString()}`"
                centered
                modal-class="modal-primary"
                ok-variant="primary"
                cancel-variant="outline-secondary"
                :title="isSurveyCreated ? $t('message.surveyCreated') : $t('message.createNewSurvey')"
                :ok-title="$t('Create')"
                :cancel-title="$t('message.cancel')"
                :ok-disabled="isSurveyCreated"
                no-close-on-backdrop
                @cancel="handleCancel"
                @ok="(event) => createSurvey(event, data.item)"
              >
                <loading 
                  v-if="isCreatingSurvey"
                  :active="true" 
                  :is-full-page="false"
                  :color="colors.primary"
                />

                <validation-observer v-if="!isSurveyCreated" ref="modalValidation" tag="form">
                  <b-form-group :label="$t('label.Name')">
                    <validation-provider :name="$t('label.Name')" rules="required" v-slot="{ errors }">
                      <b-form-input v-model="newSurvey.name" :placeholder="$t('placeholder.name')"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group :label="$t('label.Location')">
                    <validation-provider :name="$t('label.Location')" rules="required" v-slot="{ errors }">
                      <v-select v-model="newSurvey.location" label="title" :options="locations" :reduce="(location) => location.value" :placeholder="$t('placeholder.location')"/> 
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group :label="$t('label.Physical Location')">
                    <validation-provider :name="$t('label.Physical Location')" rules="required" v-slot="{ errors }">
                      <v-select v-model="newSurvey.physical_location" label="title" :options="physical_locations" :reduce="(physical_location) => physical_location.value" :placeholder="$t('placeholder.physical_location')"/> 
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                </validation-observer>

                <div v-else>
                  <b-form-group :label="$t('message.tableHeader.link')">
                    <b-input-group>
                      <!-- Input readonly para ver/copiar manualmente -->
                      <b-form-input v-model="newSurvey.link" readonly />
                      
                      <!-- Botón para abrir el link -->
                      <b-input-group-append>
                        <b-button
                          :href="newSurvey.link"
                          target="_blank"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          rel="noopener noreferrer"
                          variant="flat-primary"
                          class="btn-icon rounded-circle ml-0"
                          v-b-tooltip.hover.v-primary.bottom="`${$t('message.open')}`"
                        >
                          <feather-icon
                            size="19"
                            icon="ExternalLinkIcon"
                          />
                        </b-button>
                      </b-input-group-append>

                      <!-- Botón para copiar el link -->
                      <b-input-group-append>
                        <b-button
                          variant="flat-primary"
                          @click="copyLink(newSurvey.link)"
                          class="btn-icon rounded-circle ml-0"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          v-b-tooltip.hover.v-primary.bottom="`${$t('message.copy')}`"
                        >
                          <feather-icon
                            size="19"
                            icon="CopyIcon"
                          />
                        </b-button>
                      </b-input-group-append>

                      <!-- Botón para mandar el link al mail -->
                      <b-input-group-append>
                        <b-button
                          variant="flat-primary"
                          @click="confirmSendEmail"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          class="btn-icon rounded-circle ml-0"
                          v-b-tooltip.hover.v-primary.bottom="`${$t('message.submit')}`"
                        >
                          <feather-icon
                            size="19"
                            icon="MailIcon"
                          />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
              </b-modal>

              <b-modal
                id="send-mail-modal"
                v-model="showMailModal"
                centered
                modal-class="modal-primary"
                ok-variant="primary"
                cancel-variant="outline-secondary"
                :title="`${$t('message.sendSurveyToEmployees')} ${mailData.locationName || ''}`"
                :ok-title="$t('message.submit')"
                :cancel-title="$t('message.cancel')"
                @ok="handleSendMail"
                @cancel="showMailModal = false"
              >
                 <!-- If there are no employees in the location -->
                  <div v-if="(mailData.totalWithEmail || 0) + (mailData.totalWithoutEmail || 0) === 0">
                    <p>{{ $t('message.noEmployeesInLocation') }}</p>
                  </div>

                  <!-- If there are employees, but none have an email -->
                  <div v-else-if="mailData.totalWithEmail === 0">
                    <p>{{ $t('message.employeesWithoutEmail') }}</p>
                  </div>

                  <!-- If there are employees with an email -->
                  <div v-else>
                    <p>
                       {{ $t('message.employeesReceivingSurvey') }} <strong>{{ mailData.totalWithEmail }}</strong>
                    </p>
                    <p v-if="mailData.totalWithoutEmail > 0">
                      {{ $t('message.employeesWithoutEmailCount') }} <strong>{{ mailData.totalWithoutEmail }}</strong>
                    </p>
                  </div>
              </b-modal>

              <DeleteButton v-b-modal="`modal ${data.item._id}`"/>
              <b-modal
                :id="`modal ${data.item._id}`"
                centered
                no-close-on-backdrop
                modal-class="modal-danger"
                ok-variant="danger"
                cancel-variant="outline-secondary"
                :title="$t('message.confirm_action')"
                :ok-title="$t('message.delete')"
                :cancel-title="$t('message.cancel')"
                @ok="deleteBarometerSurveyDesigned(data.item._id)"
              >
                {{ $t('message.confirm_delete_barometer_survey') }}
              </b-modal>
            </div>
          </template>
        </b-table>
      </b-col>

      <b-col
        cols="12"
        class="d-flex justify-content-between flex-wrap"
      >
        <div class="mb-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{ $t('message.per_page') }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="perPageOptions"
              class="w-50"
            />
          </b-form-group>
        </div>

        <div class="mb-1">
          <span class="text-muted">{{ showingMessage }}</span>
        </div>

        <b-pagination
          v-model="currentPage"
          :total-rows="totalBarometerSurveysDesigned"
          :per-page="perPage"
          first-number=""
          last-number=""
          prev-class="prev-item"
          next-class="next-item"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BPagination, BTable, BModal, VBModal, BFormInput, BLink, BInputGroup, BInputGroupAppend } from 'bootstrap-vue'
import { onMounted, computed } from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'
import EditButton from '@/views/components/Shared/Buttons/EditButton.vue'
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton.vue'
import NavigationButton from '@/views/components/Shared/Buttons/NavigationButton.vue'
import useBarometerSurveyDesignedList from './useBarometerSurveyDesignedList'
import { colors } from '@/constants'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BPagination,
    EditButton,
    DeleteButton,
    NavigationButton,
    BModal,
    Loading,
    vSelect,
    ValidationObserver,
    ValidationProvider,
    BFormInput,
    BLink,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
  },
  data() {
    return {
      items: [],
    }
  },
  setup() {
    const { router } = useRouter()
    const {
      fetchBarometerSurveysDesigned,
      tableColumns,
      perPage,
      currentPage,
      perPageOptions,
      totalBarometerSurveysDesigned,
      showingMessage,
      searchQuery,
      sortBy,
      isSortDirDesc,
      barometerSurveysDesigned,
      deleteBarometerSurveyDesigned,
      isLoading,
      searchBarometerSurveyDesigned,
      newSurvey,
      modalValidation,
      isCreatingSurvey,
      createSurvey,
      getLocationsForDropDown,
      getPhysicalLocationsForDropDown,
      locations,
      physical_locations,
      isSurveyCreated,
      copyLink,
      handleSendMail,
      getEmailsWorkers,
      showMailModal,
      confirmSendEmail,
      mailData,
      handleCancel
    } = useBarometerSurveyDesignedList()

    const paginatedBarometerSurveysDesigned = computed(() => {
      const start = (currentPage.value - 1) * perPage.value
      const end = start + perPage.value
      return barometerSurveysDesigned.value.slice(start, end)
    })

    onMounted(() => {
      fetchBarometerSurveysDesigned()
      getLocationsForDropDown()
      getPhysicalLocationsForDropDown()
      getEmailsWorkers()
    })

    return {
      handleCancel,
      fetchBarometerSurveysDesigned,
      barometerSurveysDesigned,
      showingMessage,
      router,
      tableColumns,
      searchQuery,
      sortBy,
      isSortDirDesc,
      deleteBarometerSurveyDesigned,
      totalBarometerSurveysDesigned,
      currentPage,
      perPageOptions,
      perPage,
      isLoading,
      searchBarometerSurveyDesigned,
      paginatedBarometerSurveysDesigned,
      colors,
      newSurvey,
      locations,
      physical_locations,
      createSurvey,
      modalValidation,
      isCreatingSurvey,
      isSurveyCreated,
      copyLink,
      handleSendMail,
      showMailModal,
      confirmSendEmail,
      mailData
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.process-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

.form-group {
  label {
    font-size: 0.85rem;
    font-weight: 400;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
